import MobilePortalOverlay from './MobilePortalOverlay';

export default MobilePortalOverlay;
